import React from 'react'

export default function CircleRoundedGreen(props) {

    return (
        <>
            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="20.5013" cy="19.6863" rx="17.0833" ry="16.2698" fill="#35F29A" />
                <path d="M17.2251 22.8758L13.2403 19.1255L11.5293 20.7359L17.2251 26.0966L28.9712 15.0414L27.2602 13.431L17.2251 22.8758Z" fill="white" />
            </svg>

        </>
    )
}